import { Popover, Button, message } from 'antd';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TStore } from '@/common/basis/types/tstore';
import { TResponse } from '@/common/basis/types/tresponse';
import { checkBeforeJoin } from '@/common/http/meet';
import { isSuccessCode } from '@/common/utils/response';
import config from '@/common/basis/config.json';
import { defaultUserAvatar } from '@/common/utils/design';

function App(props: { setIsOpenExitLogin: (isOpenExitLogin: boolean) => void }) {
  const setIsOpenExitLogin = props.setIsOpenExitLogin;
  const currentUserName = useSelector((state: TStore.State) => state.person.user?.userName) ?? '';
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage({ top: 60 });

  // 退出跳转至Home页面
  const navigateHome = async () => {
    const resp = await checkBeforeJoin({ roomId: '' });

    if (isSuccessCode(resp.code) || resp?.code === TResponse.CODE_201) {
      setIsOpenExitLogin(true);
      setIsOpen(false);
    } else if (resp?.code === TResponse.CODE_445) {
      messageApi.destroy();
      messageApi.warning(t('leaveMeetingBeforeExit'));
    } else if (resp?.code === TResponse.CODE_444) {
      // 444:会议不存在
      if (resp.data?.clientType === config.clientId) {
        messageApi.destroy();
        messageApi.warning(t('leaveMeetingBeforeExit'));
      } else {
        setIsOpenExitLogin(true);
        setIsOpen(false);
      }
    } else {
      messageApi.destroy();
      messageApi.warning(resp?.msg);
    }

    return;
  };

  return (
    <>
      <Popover
        arrow={{ pointAtCenter: true }}
        content={
          <div className='w-40'>
            <div className='flex items-center justify-start rounded-md bg-[#0060ff] p-4'>
              <div className='flex items-center justify-start'>
                <div className='h-10 w-10 overflow-hidden rounded border-[1px] border-solid border-[#fff]'>
                  <img className='mx-auto block h-full w-full rounded object-cover' src={defaultUserAvatar} />
                </div>
                <div className='mx-2 text-[#fff]'>
                  <span className='mt-2 text-[12px]'>{currentUserName}</span>
                </div>
              </div>
            </div>
            <div className='mt-3'>
              <Button block onClick={() => navigateHome()}>
                <span>{t('logout')}</span>
              </Button>
            </div>
          </div>
        }
        destroyOnHidden
        onOpenChange={(open) => setIsOpen(open)}
        open={isOpen}
        placement='bottom'
        styles={{ body: { marginRight: 8 } }}
        trigger='click'
      >
        <div className='absolute right-3 top-3 z-50 cursor-pointer items-center justify-center no-drag'>
          <div className='relative'>
            <img className='mx-auto block h-9 w-9 rounded' src={defaultUserAvatar} />
          </div>
        </div>
      </Popover>
      {contextHolder}
    </>
  );
}

export default App;
